<template>
<div>
  <pt-system-customer-form ref="form" class="pt-system-customer-form__withData" :organizations="organizations" :rolesList="rolesList" :offices="offices"
  :userDetail="userDetail" :isEdit="isEdit"></pt-system-customer-form>
  <el-dialog title="用户创建成功" :visible.sync="is_dialog" width="30%" @close="closeDialog">
    <div>该系统用户的登录密码为<span style="font-size:15px;font-weight:600">“{{password}}”</span>请妥善保管，并发送给用户。如有丢失，请编辑该系统用户，重置密码<pt-copy-button type="text" :copyContent="password" text="[复制]"></pt-copy-button></div>
  </el-dialog>
</div>
</template>

<script>
import PtSystemCustomerForm from './form'
import { randomWord } from '@/utils/formUtils'
export default {
  name: 'pt-system-customer-form__withData',
  components: {
    PtSystemCustomerForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    userLogin: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      organizations: [],
      rolesList: [],
      offices:[],
      userDetail: {
      },
      is_dialog: false,
      password: '',
      formValue: {}
    }
  },
  methods: {
    getUserDetail () {
      this.$emit('detailLoading', true)
      this.$store.dispatch('organizationUserInformation', this.userLogin).then(res => {
        this.$emit('detailLoading', false)
        if (!res.roles) {
          res.roles = []
        }
        this.userDetail = res
      }).catch(err => {
        this.$emit('detailLoading', false)
        this.$message.error(err || '获取用户详情失败')
      })
    },
    closeDialog () {
      this.is_dialog = false
      history.go(-1)
    //   this.createdOrgCustomer(this.formValue)
    },
    submit () {
      this.form.validate().then(formValue => {
        if(formValue.password && formValue.checkPass && formValue.password !== formValue.checkPass){
          this.$message.warning('两次输入密码不一致')
          return
        }
        formValue.username = formValue.username.replace(/\s*/g, '')
        let data = {
          organizationUser: JSON.parse(JSON.stringify(formValue)),
          // password: this.isEdit ? (formValue.password || null) : randomWord(false, 24),
          password: formValue.password || null,
          roles: formValue.roles,
          // roleDisplayName: formValue.roles.map(item=>JSON.parse(item).displayName),
          departmentNames: formValue.departmentNames
          // departmentDisplayName:formValue.department.map(item=>JSON.parse(item).displayName),
        }
        this.password = data.password
        this.$delete(data.organizationUser, 'roles')
        this.formValue = data
        if (!this.isEdit) {
          this.createdOrgCustomer(data)
        } else {
          this.updateOrganizationUser(data)
        }
      })
    },
    createdOrgCustomer (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('createdOrgCustomer', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('新建组织用户成功')
        this.is_dialog = true
      }).catch(errorMessage => {
        this.$emit('submitLoading', false)
        this.$message.error(errorMessage || '新建组织用户失败')
      })
    },
    updateOrganizationUser (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('updateOrganizationUser', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('编辑组织用户成功')
        history.go(-1)
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message.error(err || '编辑组织用户失败')
      })
    },
    getOrganizations () {
      this.$store.dispatch('getOrganizationsCustomer').then(res => {
        this.organizations = res
      }).catch(err => {
        this.$message.error(err || '获取组织列表失败')
      })
    },
    getRolesList () {
      let data = {}
      this.$store.dispatch('rolesList', data).then(res => {
        this.rolesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取角色列表失败')
      })
    },
    getOfficesList () {
      this.$store.dispatch('getOffices').then(res => {
				res.data.forEach(item => {
					item.label=item.displayName
					item.value=item.id
				});
				this.offices = res.data
      }).catch(err => {
        this.$message.error(err || '获取科室列表失败')
      })
    },
    handleDelete(){
      this.$confirm(`是否删除该用户吗？`, '确认删除', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        this.$emit('submitLoading', true)
        let data = {
          userLogin: this.userDetail.organizationUser.userLogin
        }
        this.$store.dispatch('deleteOrganizationUser', data).then(res => {
          this.$message.success('操作成功')
          this.$router.push('/customer-of-system')
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(()=>{
           this.$emit('submitLoading', false)
        })
      })
    }
  },
  created () {
    this.getOrganizations()
    this.getRolesList()
    this.getOfficesList()
    if (this.isEdit) {
      this.getUserDetail()
    }
  }
}
</script>
